// Third-party libraries
import React, { useContext, useState } from "react";

// Local modules
import { storage } from "../../utils";
import { DiamondSearchContext } from "../../utils/stateHandlers/contexts";
import AccordionDiamondFilter from "./AccordionDiamondFilter";
import DiamondFilter from "./DiamondFilter";
import useMediaQueryUtils from "../../utils/mediaQueryUtils";

export default function CertDiamondFilters(props) {
  const isMdScreen = useMediaQueryUtils("md");
  const { diamondState, dispatch } = useContext(DiamondSearchContext);
  const { searchQuery } = diamondState;
  const [localFcIntensity, setLocalFcIntensity] = useState(["None"]);
  const loggedIn = storage.getStorageItem("authToken");
  const { setView, toggleView, isBuilder } = props;

  const searchFields = Array.isArray(searchQuery?.fields)
    ? [...searchQuery.fields]
    : [];
  const valuesForColor = searchFields.find(function (field) {
    return field.name === "MinedOrLab";
  });

  const valueForColor = valuesForColor?.values?.[0]?.name ?? null;

  function updateFilters(filterName, filterValues) {
    const rangeOrValues =
      filterName === "HooverPrice" ||
      filterName === "Carat" ||
      filterName === "LWRatio" ||
      filterName === "Table" ||
      filterName === "Depth"
        ? "range"
        : "values";

    if (filterName === "MinedOrLab") {
      clearFilters();
    }

    const currentFields = Array.isArray(searchQuery?.fields)
      ? [...searchQuery.fields]
      : [];

    const existingIndex = currentFields.findIndex(function (field) {
      return field.name === filterName;
    });

    let updatedFields = currentFields;

    if (existingIndex >= 0) {
      const existingField = currentFields[existingIndex] || {};
      const { range, values, ...rest } = existingField;

      updatedFields[existingIndex] =
        rangeOrValues === "range"
          ? { ...rest, name: filterName, range: filterValues }
          : { ...rest, name: filterName, values: filterValues };
    } else {
      const newField =
        rangeOrValues === "range"
          ? { name: filterName, range: filterValues }
          : { name: filterName, values: filterValues };

      updatedFields = currentFields.concat(newField);
    }

    dispatch({ type: "updateSearchQuery", payload: updatedFields });
  }

  function clearFilters(minedOrLab) {
    setView("list");
    dispatch({
      type: "updateSort",
      payload: {
        sortField: "Carat",
        sortDirection: "desc",
      },
    });
    dispatch({ type: "setOpenPanel", payload: false });
  }

  function updateCheckedBoxes(filterName, values) {
    if (
      filterName === "AsGrown" ||
      filterName === "ScsGrower" ||
      filterName === "ShipsSameDay" ||
      filterName === "ImageVideoAvailable"
    ) {
      if (values.checked === "N") {
        const currentFields = Array.isArray(searchQuery?.fields)
          ? searchQuery.fields
          : [];
        const newSearchQuery = currentFields.filter(function (queryField) {
          return queryField.name !== filterName;
        });
        dispatch({ type: "updateSearchQuery", payload: newSearchQuery });
      } else {
        updateFilters(filterName, [{ name: values.checked }]);
      }
    } else {
      const searchValues = values
        .filter(function (value) {
          return value.checked === true;
        })
        .map(function (value) {
          return { name: value.name };
        });
      updateFilters(filterName, searchValues);
    }
  }

  function updateRange(filterName, range) {
    updateFilters(filterName, range);
  }

  function updateNominalRange(filterName, marks, sliderValue) {
    const newArray = marks
      .filter(
        (m) => m.value + 0.1 > sliderValue[0] && m.value + 0.1 < sliderValue[1]
      )
      .map((m) => {
        return { name: m.label };
      });
    updateFilters(filterName, newArray);
  }

  function switchToFancyColors(color) {
    dispatch({ type: "setOpenPanel", payload: false });
    dispatch({
      type: "setShowFancyColorFilter",
      payload: color !== "White",
    });
    toggleView("", "grid");
    setView("grid");

    const currentFields = Array.isArray(searchQuery?.fields)
      ? [...searchQuery.fields]
      : [];

    if (color !== "White") {
      const filtered = currentFields.filter(function (field) {
        return field.name !== "Color";
      });

      dispatch({ type: "updateSearchQuery", payload: filtered });
    } else {
      const fancyFieldNames = new Set([
        "FancyColor",
        "FancyColorIntensity",
        "FancyColorOvertone",
      ]);

      let filtered = currentFields.filter(function (field) {
        return !fancyFieldNames.has(field.name);
      });

      const hasColorField = filtered.some(function (field) {
        return field.name === "Color";
      });

      if (!hasColorField) {
        const defaultWhiteValues = ["D", "E", "F", "G", "H", "I", "J", "K"].map(
          function (name) {
            return { name };
          }
        );

        filtered = filtered.concat({
          name: "Color",
          values: defaultWhiteValues,
        });
      }

      setLocalFcIntensity(["None"]);
      dispatch({ type: "updateSearchQuery", payload: filtered });
    }
  }
  return (
    <>
      {isMdScreen ? (
        <AccordionDiamondFilter
          updateCheckedBoxes={updateCheckedBoxes}
          localFcIntensity={localFcIntensity}
          setLocalFcIntensity={setLocalFcIntensity}
          switchToFancyColors={switchToFancyColors}
          updateNominalRange={updateNominalRange}
          updateFilters={updateFilters}
          valueForColor={valueForColor}
          updateRange={updateRange}
          loggedIn={loggedIn}
          clearFilters={clearFilters}
          isBuilder={isBuilder}
        />
      ) : (
        <DiamondFilter
          updateCheckedBoxes={updateCheckedBoxes}
          localFcIntensity={localFcIntensity}
          setLocalFcIntensity={setLocalFcIntensity}
          switchToFancyColors={switchToFancyColors}
          updateNominalRange={updateNominalRange}
          valueForColor={valueForColor}
          updateRange={updateRange}
          loggedIn={loggedIn}
          updateFilters={updateFilters}
          clearFilters={clearFilters}
          setImageToggle={props.setImageToggle}
          imageToggle={props.imageToggle}
          isBuilder={isBuilder}
        />
      )}
    </>
  );
}
